import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardThemeService {
  private themeSubject = new BehaviorSubject<string>(undefined);
  theme$: Observable<string> = this.themeSubject.asObservable();

  constructor() {}

  changeTheme(theme: any) {
    this.themeSubject.next(theme);
  }
}
